<template>
    <ListeProduitIventaire />
</template>
  
<script lang="ts">
  import { defineComponent } from "vue";
  import ListeProduitIventaire from "@/components/GesCom/Inventaire/ListeProduitIventaire.vue";
  export default defineComponent({
    name: "ListeProduitIventairePage",
    components: {
      ListeProduitIventaire,
    },
  });
</script>